"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFromMap = void 0;
var getFromMap = function (ids, map) {
    if (!ids)
        return;
    return ids.map(function (id) { return map[id]; });
};
exports.getFromMap = getFromMap;
//# sourceMappingURL=getFromMap.js.map